// extracted by mini-css-extract-plugin
var _1 = "RestrictedViewStyle-module__container___TBWq0";
var _2 = "RestrictedViewStyle-module__header___yBOap";
var _3 = "RestrictedViewStyle-module__icon-container___SkKZP";
var _4 = "RestrictedViewStyle-module__icon-container___SkKZP";
var _5 = "RestrictedViewStyle-module__inner-wrapper___dWx5T";
var _6 = "RestrictedViewStyle-module__inner-wrapper___dWx5T";
var _7 = "RestrictedViewStyle-module__support-url___glRQe";
var _8 = "RestrictedViewStyle-module__support-url___glRQe";
var _9 = "RestrictedViewStyle-module__text-style___a2U2I";
var _a = "RestrictedViewStyle-module__text-style___a2U2I";
export { _1 as "container", _2 as "header", _3 as "icon-container", _4 as "iconContainer", _5 as "inner-wrapper", _6 as "innerWrapper", _7 as "support-url", _8 as "supportUrl", _9 as "text-style", _a as "textStyle" }
